// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.user.UserRole
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { KendoObservableObjectProxy } from "abweb/dto/kendo/KendoObservableObjectProxy";
export class UserRole extends KendoObservableObjectProxy {
  static createUserRole(id, name) {
    const retVal = new UserRole();
    retVal.initUserRole(id, name);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createUserRole factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadu.UserRole";
  }
  initFromJson(json, deserializeContext) {
    this.initUserRole(json.id != null ? json.id : null, json.name != null ? json.name : null);
  }
  initUserRole(id, name) {
    this.initKendoObservableObjectProxy();
    this._id = id;
    this._name = name;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    retVal["id"] = this._id;
    retVal["name"] = this._name;
    return retVal;
  }
  get id() {
    return this._id;
  }
  set id(value) {
    this._id = value;
  }
  get name() {
    return this._name;
  }
  set name(value) {
    this._name = value;
  }
}
//# sourceMappingURL=UserRole.js.map
